import SocialShare from './SocialShare';

const socialShare = new SocialShare();
socialShare.init();
